// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 排序类型 枚举类
 * 排序类型
 */
export enum EnumOrderType {
  /** 升序 : 升序 */
  ASC = 1,
  /** 降序 : 降序 */
  DESC = 2
}

/**
 * 排序类型 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumOrderTypeMD {
  private static items = [
    new EnumItemMD('ASC', 1, '升序', '升序'),
    new EnumItemMD('DESC', 2, '降序', '降序')
  ];

  static getItem(enumItem: EnumOrderType) {
    return this.items.find(item => item.name === EnumOrderType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
